import { useMemo } from "react"

import { CollaboratorRole } from "@/domain/collaborator/constants"
import { isNotNullNorUndefined } from "@/utils/ts-utils"

import useGetUserInfos from "./useGetUserInfos"
import useGetUserRoles from "./useGetUserRoles"

// "My agency" entry of the Network section: shown to BU managers with a default agency, in the
// plural when they manage several. Shared by the sidebar entry and the Network routes.
export default function useMyAgencyNav() {
  const { defaultCluster, clusterIdsByRole } = useGetUserInfos()
  const managedAgenciesCount = (clusterIdsByRole[CollaboratorRole.MANAGER] ?? []).length
  const { hasSomeRoleBuAdmin } = useGetUserRoles()

  const displayMyAgency = useMemo(
    () => hasSomeRoleBuAdmin() && isNotNullNorUndefined(defaultCluster),
    [hasSomeRoleBuAdmin, defaultCluster]
  )

  return {
    displayMyAgency,
    myAgencyLabelId: managedAgenciesCount > 1 ? "network.my_agencies" : "network.my_agency",
  }
}
